import * as React from "react";
import SmsProvider from "./SmsProvider";

const PanaceaMobile = props => <SmsProvider name="panacea" {...props} />;
const Clickatell = props => <SmsProvider name="clickatell" {...props} />;

export { PanaceaMobile, Clickatell };
